module.exports = __webpack_public_path__ + "static/media/1019665.52334474.jpg";